import { InvestorType } from "./persona";

// Option lists and limits for the company profile, shared by the onboarding form
// and the settings editor so the two can't drift.

export const SECTORS = [
  "Technology",
  "Healthcare",
  "Financial Services",
  "Consumer",
  "Enterprise Software",
  "Marketplace",
  "Hardware",
  "Energy",
  "Education",
  "Real Estate",
  "Other",
] as const;

export const STAGES = [
  "Pre-Seed",
  "Seed",
  "Series A",
  "Series B",
  "Series C",
  "Growth",
  "Other",
] as const;

export const INVESTOR_TYPES: { value: InvestorType; label: string }[] = [
  { value: "venture_fund", label: "Venture Fund" },
  { value: "accelerator", label: "Accelerator" },
  { value: "incubator", label: "Incubator" },
  { value: "angel", label: "Angel" },
  { value: "family_office", label: "Family Office" },
  { value: "corporate", label: "Corporate" },
  { value: "other", label: "Other" },
];

// Matches the company-logos bucket; the backend enforces these too.
export const MAX_LOGO_BYTES = 1024 * 1024;
export const ACCEPTED_LOGO_TYPES = ["image/png", "image/jpeg"];

// Mirrors maxDescriptionChars in the Go service.
export const MAX_DESCRIPTION_CHARS = 500;

// The investor portfolio table shows a description as one truncated line, so the startup field asks for a one-liner first.
export const STARTUP_DESCRIPTION_PLACEHOLDER = "What your company does, in one sentence.";
export const STARTUP_DESCRIPTION_HINT =
  "Lead with a one-line summary. Investors see it under your name in their portfolio.";

// Resolves to the file as a data URI, or to a message to show under the field.
export function readLogoFile(file: File): Promise<{ dataUri: string } | { error: string }> {
  if (!ACCEPTED_LOGO_TYPES.includes(file.type)) {
    return Promise.resolve({ error: "Use a PNG or JPEG image." });
  }
  if (file.size > MAX_LOGO_BYTES) {
    return Promise.resolve({ error: "That image is too large. Logos must be under 1 MB." });
  }
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = () => resolve({ dataUri: typeof reader.result === "string" ? reader.result : "" });
    reader.onerror = () => resolve({ error: "We couldn't read that image. Please try another file." });
    reader.readAsDataURL(file);
  });
}
